import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-audit-builder',
  templateUrl: './audit-builder.component.html',
  styleUrls: ['./audit-builder.component.scss']
})
export class AuditBuilderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
